import Vuetify from 'vuetify/lib';

import preset from './vuetify-preset';

export default new Vuetify(preset);
